import type { FunctionComponent, SVGProps } from 'react';

import TriangleDashed from '@/assets/icons/triangle-dashed.svg?react';
import HexagonDashed from '@/assets/icons/hexagon-dashed.svg?react';
import RectangleDashed from '@/assets/icons/rectangle-dashed.svg?react';

import HexagonKey from '@/assets/images/1-key-hexagon.svg?react';
import TriangleKey from '@/assets/images/1-key-triangle.svg?react';
import RectangleKey from '@/assets/images/1-key-rectangle.svg?react';

export const KEYS_FOR_ANIMATION: FunctionComponent<SVGProps<SVGSVGElement>>[] = [TriangleKey, HexagonKey, RectangleKey, TriangleKey, HexagonKey, RectangleKey];
export const KEYS_CSS_SELECTOR_PREFIX = 'key';
export const KEY_ANIMATION_FADING_MILLISECONDS = 2000;
export const KEY_ANIMATION_DELAY_BETWEEN_MILLISECONDS = 500;

export const SHAPES: FunctionComponent<SVGProps<SVGSVGElement>>[] = [TriangleDashed, HexagonDashed, RectangleDashed];

export const CORRECT_CODES = ['124', '909', '340'];
